module.exports = __webpack_public_path__ + "img/huiyishenqing.332f6ac3.png";